import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./MatModal.module.scss";

function MatModal({
  modalTitle,
  modalContent,
  open,
  setOpen,
  width,
  footer = false,
}: any) {
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      fullWidth
      maxWidth="md"
      PaperProps={{
        style: width ? { width } : {},
      }}
    >
      <DialogTitle sx={{ m: 0, p: 2 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <span>{modalTitle}</span>
          <IconButton
            aria-label="close"
            onClick={() => setOpen(false)}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent dividers>{modalContent}</DialogContent>

      {footer && (
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={() => setOpen(false)}>
            Ok
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
}

export default MatModal;
